<template>
  <div>
    <Title :pages="[{ icon: 'bullhorn', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="news-wall">
        <v-btn v-if="create_access" color="primary" class="mb-5" @click="openModal(null)">Nueva novedad</v-btn>

        <div v-if="loading && list.length == 0" class="pa-6 text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else-if="load_error" class="news-wall__empty">
          <p>No se pudieron cargar las novedades.</p>
          <v-btn text color="primary" @click="reload">Reintentar</v-btn>
        </div>
        <div v-else-if="list.length == 0" class="news-wall__empty">
          <v-icon large color="grey lighten-1">mdi-bullhorn-outline</v-icon>
          <p>Todavía no hay novedades.</p>
        </div>

        <div class="news-wall__list">
          <NewsCard v-for="item in list" :key="item.id" :item="item" :can_update="update_access" :can_delete="delete_access" @edit="openModal" @remove="askRemove" />
        </div>

        <div v-if="list.length < total" class="text-center mt-4">
          <v-btn text color="primary" :loading="loading" @click="load">Ver más</v-btn>
        </div>
      </div>
    </v-container>

    <ModalNews v-if="create_access || update_access" :dialog="dialog" :item="editing" @close="dialog = false" @saved="onSaved" />
    <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="dialog_delete = false" @deleteItemConfirm="remove" />
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { newsService } from "@/libs/ws/newsService";
import NewsCard from "./NewsCard.vue";
import ModalNews from "./ModalNews.vue";

export default {
  name: "News",
  components: { Title, DialogDelete, NewsCard, ModalNews },
  mixins: [RolMixin],
  data() {
    return {
      page_title: "Novedades",
      list: [],
      total: 0,
      loading: false,
      load_error: false,
      dialog: false,
      editing: null,
      dialog_delete: false,
      deleting: null,
    };
  },
  computed: {
    can_manage() {
      return this.create_access || this.update_access || this.delete_access;
    },
  },
  mounted() {
    // Entrar a la seccion es darse por enterado: se marca despues de traer el listado, para que lo nuevo se vea como nuevo
    this.load().then(this.markRead);
  },
  methods: {
    load() {
      this.loading = true;
      this.load_error = false;
      const param = { offset: this.list.length };
      return (this.can_manage ? newsService.filter(param) : newsService.myFilter(param))
        .then((response) => {
          if (response.status) {
            this.list = this.list.concat(response.result.list);
            this.total = response.result.total;
          } else {
            this.load_error = this.list.length == 0;
            this.$toast.error(response.msg, "Error");
          }
          return response.status;
        })
        .catch(() => {
          this.load_error = this.list.length == 0;
          return false;
        })
        .finally(() => (this.loading = false));
    },
    reload() {
      this.list = [];
      return this.load();
    },
    markRead(loaded) {
      // Sin listado el usuario no vio nada: el aviso tiene que seguir
      if (!loaded) return;
      newsService
        .readAll()
        .then((response) => {
          if (response.status) this.$root.$emit("news-read");
        })
        .catch((e) => console.log(e));
    },
    openModal(item) {
      this.editing = item;
      this.dialog = true;
    },
    onSaved() {
      this.dialog = false;
      this.reload();
    },
    askRemove(item) {
      this.deleting = item;
      this.dialog_delete = true;
    },
    remove() {
      this.dialog_delete = false;
      newsService
        .remove(this.deleting.id)
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.reload();
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch(() => this.$toast.error("No se pudo eliminar la novedad.", "Error"));
    },
  },
};
</script>

<style scoped>
.news-wall {
  max-width: 820px;
  margin: 0 auto;
}
.news-wall__list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.news-wall__empty {
  padding: 48px 16px;
  text-align: center;
  color: #64748b;
}
.news-wall__empty p {
  margin: 8px 0 0;
}
</style>
